import React from "react";
import { Button } from "antd";
import Modal from "react-bootstrap/Modal";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import {
  openNotificationType,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import { NOTIFICATIONS } from "../../../LandingPage/constants";
import RegistrationDataProvider from "../../../LandingPage/Screens/Registration/RegistrationFormView/RegistrationDataProvider";

class RegistrationTimer extends React.Component {
  DataProvider = new RegistrationDataProvider();

  state = {
    seconds: localStorage.getItem("registration-otp-duration"),
    isLoading: false,
  };

  componentDidMount() {
    this.startTimer();
  }

  startTimer = () => {
    try {
      if(this.state.seconds === null){
        return;
      }
      const t = setInterval(() => {
        this.setState({ seconds: this.state.seconds - 1 }, () => {
          if (this.state.seconds === 0) {
            clearInterval(t);
          }
        });
      }, 1000);
    } catch (error) {}
  };

  resendOtp = () => {
    try {
          this.setState({ isLoading: true });
          this.DataProvider.generate_registration_otp(this.props.registrationOtpPayload)
            .then((res) => {
              if (res.ok) {
                return res.json().then((res) => {
                  this.setState({ isLoading: false });
                  openNotification(
                    openNotificationType.success,
                    res.Success
                  );
                  localStorage.setItem("registration-otp-duration", res.duration);
                  this.setState({ isLoading: false, seconds: res.duration }, () => {
                    this.startTimer();
                  });
                });
              }
              else {
                this.setState({ isLoading: false });
                return res.json().then((res) => {
                  Object.keys(res).map((error) => {
                    openNotification(openNotificationType.error, error, res[error]);
                  });
                });
              }
            })
            .finally(() =>
              this.setState({
                isLoading: false
              })
            );
        } catch (error) {
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  render() {
    const { seconds, isLoading } = this.state;
    const { formRef } = this.props;
    return (
      <>
        <Modal show={isLoading} centered>
          <Modal.Body>
            <FormLoader loading="true" />
          </Modal.Body>
        </Modal>

        <AndtDTextBoxWrapper
          decorator="registration_otp"
          id="registration_otp"
          required="true"
          label="OTP"
          message="Enter OTP"
          placeholder="Enter OTP"
          validators=""
          disabled={seconds === 0 ? true : false}
          formRef={formRef}
        />

        {seconds === 0 ? (
          <Button type="link" onClick={this.resendOtp}>
            Resend OTP
          </Button>
        ) : (
          <p className="otp-text">
            OTP expire in &nbsp;
            <font color="red">{seconds}</font> seconds
          </p>
        )}
      </>
    );
  }
}

export default RegistrationTimer;
